export class MenuSubMenu {
  constructor(
    id = "",
    name = "",
    slug_url = "",
    icon = "",
    image = "",
    subMenu = []
  ) {
    this.id = id;
    this.name = name;
    this.slug_url = slug_url;
    this.icon = icon;
    this.image = image;
    this.subMenu = subMenu;
  }
}
